import { observer } from 'mobx-react-lite'
import { Error } from 'shared/ui'
import { ToggleChipGroup } from 'pages/chatbot/ui/UnifiedAgent/ui/BookingSection/ui/ToggleChipGroup/ToggleChipGroup'
import type { GoogleCalendarPickerStore } from 'pages/chatbot/ui/UnifiedAgent/ui/BookingSection/store/googleCalendarPickerStore'
import styles from 'pages/chatbot/ui/UnifiedAgent/ui/BookingSection/styles.module.scss'

type IBookingStepDurationProps = {
  googleCalendarPickerStore: GoogleCalendarPickerStore
}

export const BookingStepDuration = observer(
  ({ googleCalendarPickerStore }: IBookingStepDurationProps) => {
    const { durationOptions, durations, toggleDuration, durationsError } = googleCalendarPickerStore

    return (
      <div className={styles.list}>
        <ToggleChipGroup
          items={durationOptions}
          columns={4}
          isActive={(minutes) => durations.includes(minutes)}
          getLabel={(minutes) => `${minutes} min`}
          onToggle={toggleDuration}
        />
        <Error type={'text'} error={durationsError} />
      </div>
    )
  }
)
